import { render, staticRenderFns } from "./AbstractPrivacyPage.vue?vue&type=template&id=5207ba94"
import script from "./AbstractPrivacyPage.vue?vue&type=script&lang=js"
export * from "./AbstractPrivacyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports